<template>
  <div class="login-box-dialog">
    <div class="Detail-minProgram-panel">
      <div class="share-choice-mask" id="maskBtn"></div>
      <div class="minProgram-panel">
        <div class="new-share-minImg">
          <img
           @click="close"
            class="close-btn"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220822/2022-08-22/5f5d31dc74ac3f4a2a3bf90e555aa4db.png"
            alt=""
          />
          <div class="panel-title">
            <template v-if="type">
              {{productList[targetIndex].name}}
            </template>
            <template v-else>
              微信安全登录
            </template>
            </div>
          <div class="QRCode-img">
            <img :src="src" id="scan-login-code" />
          </div>
          <div class="min-tips" id="minTips">
            <template v-if="type">
              使用微信 扫描二维码付款
            </template>
            <template v-else>
              <p>关注 "立吉答题" 服务号完成注册</p>
              <p>
                扫码注册后代表您阅读并同意
                <span @click="toAgreement" class="pointerLink">
                  《用户协议》
                </span>
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      value: ''
    },
    type: {
      type: Number || String,
      value: 0
    },
    targetIndex: {
      type: Number,
      value: 1
    },
    payType: {
      type: Number,
      value: 0
    },
    productList: {
      type: Array,
      value: []
    }
  },
  data() {
    return {
    };
  },
  methods: {
    toAgreement() {
      this.$router.push({name: 'agreement'})
    },
    close() {
      this.$emit("hideVisible");
    },
    toFile() {
      this.$router.push({ name: "agreement" });
    }
  }
};
</script>

<style lang="scss" scoped>
.Detail-minProgram-panel {
  .share-choice-mask {
    position: fixed;
    z-index: 101;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .minProgram-panel {
    width: 80%;
    position: fixed;
    z-index: 102;
    top: 20%;
    left: 10%;
    display: flex;
    justify-content: center;
    .new-share-minImg {
      position: relative;
      max-width: 400px;
      min-width: 350px;
      padding: 30px 25px 25px 25px;
      background-color: #ffffff;
      border-radius: 4px;
      box-sizing: border-box;
    }
    .new-share-text {
      padding: 30px 20px 25px 20px;
      text-align: left;
      .QRCode-text {
        font-size: 14px;
        color: #333;
        border-radius: 5px;
        padding: 10px;
        line-height: 1.5;
        word-break: break-all;
        margin: 30px 0 20px 0;
        border: 2px solid #ccc;
        background-color: #f8f8f8;
      }
      .text-tips {
        color: #999;
        font-size: 12px;
      }
      .btn-copy {
        color: #fff;
        background-color: #00a8f3;
        font-size: 16px;
        margin-top: 20px;
      }
    }
    .close-btn {
      width: 20px;
      height: 20px;
      display: inline-block;
      position: absolute;
      top: 15px;
      right: 15px;
      cursor: pointer;
    }
    .panel-title {
      font-size: 24px;
      color: #333333;
      text-align: center;
      line-height: 60px;
    }
    .panple-dis {
      width: 84%;
      margin-left: 8%;
      font-size: 13px;
      color: #333333;
      margin-top: 15px;
      line-height: 18px;
    }
    .QRCode-img {
      text-align: center;
      padding: 20px 0 10px 0;
      img {
        // width: 50%;
        width: 200px;
        height: 200px;
      }
    }
    .min-tips {
      text-align: center;
      font-size: 14px;
      color: #666666;
      line-height: 30px;
      a {
        font-size: 14px;
        color: #1890ff;
        margin-right: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/scanLogin.vue